module.exports = __webpack_public_path__ + "img/624.Dirty_ables.e1baa556.svg";